import { Placement } from 'react-joyride';
import { BaseTour } from '../types';

export class TopWidgetTour extends BaseTour {
  id = 'top-widget';
  content = 'Top Widget Tour';
  placement: Placement = 'bottom';
  steps = {
    logo: () => ({
      content: 'Welcome to FREYA! You can always click here to return to the landing page.',
    }),
    uploadButton: () => ({
      content: 'Upload your new invoices here to start the audit process.',
    }),
    searchBar: () => ({
      content: 'Quickly find invoices or shipments by their number.',
    }),
    notif: () => ({
      content: 'Stay updated on new uploads and system activity with a 30-day notification history.',
    }),
    userProfile: () => ({
      content: 'Select your entity here to switch between different business units. The platform data will update based on your selection.',
    }),
  } as const;
}
